import { AvatarBeard, STYLES as BEARD_STYLES } from './Pieces/Beard'
import { AvatarBody, STYLES as BODY_STYLES } from './Pieces/Body'
import { AvatarEyes, STYLES as EYES_STYLES } from './Pieces/Eyes'
import { AvatarHair, STYLES as HAIR_STYLES } from './Pieces/Hair'
import { AvatarHead, STYLES as HEAD_STYLES } from './Pieces/Head'
import { AvatarMouth, STYLES as MOUTH_STYLES } from './Pieces/Mouth'
import { AvatarNose, STYLES as NOSE_STYLES } from './Pieces/Nose'
import { AvatarShirt, STYLES as SHIRT_STYLES } from './Pieces/Shirt'

export const defaultConfig = {
  bgColor: '#fff'
}
export const defaultColors = [
  {
    slug: 'color1',
    kind: 'solid',
    colors: ['#42342d']
  },
  {
    slug: 'color2',
    kind: 'solid',
    colors: ['#0D98BA']
  },
  {
    slug: 'color3',
    kind: 'solid',
    colors: ['#f1c40f']
  },
  {
    slug: 'color4',
    kind: 'solid',
    colors: ['#8e44ad']
  }
]
export const bodyColors = [
  {
    slug: 'color1',
    kind: 'solid',
    colors: ['#f2ad97', '#f5ac8e', '#f9ab80', '#faa67d', '#fe9a75', '#ff9673']
  },
  {
    slug: 'color2',
    kind: 'solid',
    colors: ['#95492c', '#913e3b', '#8e3646', '#7e3a41', '#733c3e', '#553c3e']
  }
]
export const hairColors = [
  {
    slug: 'color1',
    kind: 'solid',
    colors: ['#4b264f', '#5f1945']
  },
  {
    slug: 'color2',
    kind: 'solid',
    colors: ['#371813', '#371813']
  },
  {
    slug: 'color3',
    kind: 'solid',
    colors: ['#1B1B26', '#1B1B26']
  },
  {
    slug: 'color4',
    kind: 'solid',
    colors: ['#FFB396', '#FFE0BB']
  }
]
export const defaultOptions = {
  body: {
    name: 'Cor de pele',
    icon: 'child',
    component: AvatarBody,
    styles: Object.keys(BODY_STYLES),
    colors: bodyColors
  },

  head: {
    name: 'Cabeça',
    icon: 'head-side',
    component: AvatarHead,
    styles: Object.keys(HEAD_STYLES)
  },
  hair: {
    name: 'Cabelo',
    icon: 'user-hair',
    component: AvatarHair,
    styles: Object.keys(HAIR_STYLES),
    colors: hairColors
  },
  eyes: {
    name: 'Olhos',
    component: AvatarEyes,
    icon: 'eyes',
    styles: Object.keys(EYES_STYLES),
    colors: [
      {
        slug: 'color1',
        kind: 'solid',
        colors: ['#25110d']
      }
    ]
  },
  nose: {
    name: 'Narizes',
    icon: 'nose',
    component: AvatarNose,
    styles: Object.keys(NOSE_STYLES),
    colors: [
      {
        slug: 'color1',
        kind: 'solid',
        colors: ['#FF7777']
      }
    ]
  },
  mouth: {
    name: 'Bocas',
    icon: 'lips',
    component: AvatarMouth,
    styles: Object.keys(MOUTH_STYLES),
    colors: [
      {
        slug: 'color1',
        kind: 'solid',
        colors: ['#25110d']
      }
    ]
  },
  beard: {
    name: 'Barbas',
    icon: 'mustache',
    component: AvatarBeard,
    styles: Object.keys(BEARD_STYLES),
    colors: hairColors
  },

  shirt: {
    name: 'Camisa',
    icon: 'shirt',
    component: AvatarShirt,
    styles: Object.keys(SHIRT_STYLES),
    colors: [
      {
        slug: 'color1',
        kind: 'solid',
        colors: ['#F3F7FF']
      },
      {
        slug: 'color2',
        kind: 'solid',
        colors: ['#3C3C3C']
      },
      {
        slug: 'color3',
        kind: 'solid',
        colors: ['#FFA541']
      },
      {
        slug: 'color4',
        kind: 'solid',
        colors: ['#759A23']
      },
      {
        slug: 'color5',
        kind: 'solid',
        colors: ['#108E8B']
      },
      {
        slug: 'color6',
        kind: 'solid',
        colors: ['#B21919']
      }
    ]
  }
}

export const getRandomConfig = (options = defaultOptions, fixedConfig = {}) => {
  let config = {}

  Object.keys(options).forEach(key => {
    const option = options[key]

    config[key] = {
      style: option.styles[Math.floor(Math.random() * option.styles.length)],
      color: null
    }

    if (option.colors && option.colors.length)
      config[key].color =
        option.colors[Math.floor(Math.random() * option.colors.length)].slug
  })

  config = { ...config, ...fixedConfig }

  config.head.color = config.body.color

  return {
    bgColor: defaultConfig.bgColor,
    ...config
  }
}

export const configHasChanges = (config1, config2) => {
  return JSON.stringify(config1) !== JSON.stringify(config2)
}
